// a collection of small javascript extensions and jquery plugins collected from the web

//http://www.zehnet.de/2010/11/19/document-elementfrompoint-a-jquery-solution/
(function($) {
  var check = false,
    isRelative = true;

  $.elementFromPoint = function(x, y) {
    if (!document.elementFromPoint) return null;

    if (!check) {
      var sl;
      if ((sl = $(document).scrollTop()) > 0) {
        isRelative =
          document.elementFromPoint(0, sl + $(window).height() - 1) == null;
      } else if ((sl = $(document).scrollLeft()) > 0) {
        isRelative =
          document.elementFromPoint(sl + $(window).width() - 1, 0) == null;
      }
      check = sl > 0;
    }

    if (!isRelative) {
      x += $(document).scrollLeft();
      y += $(document).scrollTop();
    }

    return document.elementFromPoint(x, y);
  };

  $.elementUnderMouseEvent = function(e) {
    return $.elementFromPoint(e.clientX, e.clientY);
  };
})(jQuery);

(function($) {
  // the jquery function serializeArray serializes the array in the format [{'name':_, 'value':_}, ...], but
  // we want it in this format {'field1': value, 'field2': value,...}
  // taken from http://jsfiddle.net/sxGtM/3/
  $.fn.serializeObject = function() {
    var o = {};
    var a = this.serializeArray();
    $.each(a, function() {
      if (o[this.name] !== undefined) {
        if (!o[this.name].push) {
          o[this.name] = [o[this.name]];
        }
        o[this.name].push(this.value || "");
      } else {
        o[this.name] = this.value || "";
      }
    });
    return o;
  };
})(jQuery);

/******************************************************************************
 ** Javascript Extensions
 ******************************************************************************/

// A var storing all useful keys for easy access
export const KEYCODES = {
  BACKSPACE: 8,
  TAB: 9,
  ENTER: 13,
  SHIFT: 16,
  CTRL: 17,
  ALT: 18,
  PAUSE: 19,
  CAPSLOCK: 20,
  ESC: 27,
  PAGEUP: 33,
  PAGEDOWN: 34,
  END: 35,
  HOME: 36,
  LEFTARROW: 37,
  UPARROW: 38,
  RIGHTARROW: 39,
  DOWNARROW: 40,
  INSERT: 45,
  DELETE: 46,
  "0": 48,
  "1": 49,
  "2": 50,
  "3": 51,
  "4": 52,
  "5": 53,
  "6": 54,
  "7": 55,
  "8": 56,
  "9": 57,
  A: 65,
  B: 66,
  C: 67,
  D: 68,
  E: 69,
  F: 70,
  G: 71,
  H: 72,
  I: 73,
  J: 74,
  K: 75,
  L: 76,
  M: 77,
  N: 78,
  O: 79,
  P: 80,
  Q: 81,
  R: 82,
  S: 83,
  T: 84,
  U: 85,
  V: 86,
  W: 87,
  X: 88,
  Y: 89,
  Z: 90,
  "0NUMPAD": 96,
  "1NUMPAD": 97,
  "2NUMPAD": 98,
  "3NUMPAD": 99,
  "4NUMPAD": 100,
  "5NUMPAD": 101,
  "6NUMPAD": 102,
  "7NUMPAD": 103,
  "8NUMPAD": 104,
  "9NUMPAD": 105,
  MULTIPLY: 106,
  PLUS: 107,
  MINUT: 109,
  DOT: 110,
  SLASH1: 111,
  F1: 112,
  F2: 113,
  F3: 114,
  F4: 115,
  F5: 116,
  F6: 117,
  F7: 118,
  F8: 119,
  F9: 120,
  F10: 121,
  F11: 122,
  F12: 123,
  EQUAL: 187,
  COMA: 188,
  SLASH: 191,
  BACKSLASH: 220
};



// WEBPACK FOOTER //
// ./enso_cms/static/enso-cms/js/third-party.js